import { render, staticRenderFns } from "./DocumentDesignConfig.vue?vue&type=template&id=be0d050a&scoped=true"
import script from "./DocumentDesignConfig.vue?vue&type=script&lang=js"
export * from "./DocumentDesignConfig.vue?vue&type=script&lang=js"
import style0 from "./DocumentDesignConfig.vue?vue&type=style&index=0&id=be0d050a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0d050a",
  null
  
)

export default component.exports